import React from 'react';
import PropTypes from 'prop-types';
import ClaudeOCRBatchQueue from '../components/ClaudeOCRBatchQueue';

/**
 * OCR page - Unified invoice upload and processing interface.
 *
 * Supports uploading one or multiple PDFs into a queue, processing each
 * with COGSLOG, and reviewing/saving extracted data one at a time.
 *
 * @param {Object} props
 * @param {string|number} [props.activeBusiness] - Currently selected business ID from App header
 * @component
 */
function OCR({ activeBusiness }) {
  return (
    <div>
      {/* Page Header */}
      <div className="page-header">
        <h1 className="page-title">Upload Invoice</h1>
        <p className="page-subtitle">
          Upload one or more invoice PDFs. COGSLOG will extract all data including
          line items, totals, and category suggestions.
        </p>
      </div>

      <ClaudeOCRBatchQueue activeBusiness={activeBusiness} />
    </div>
  );
}

OCR.propTypes = {
  /** Currently selected business ID from App header */
  activeBusiness: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default OCR;
